<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M19 13.0002H5C4.45 13.0002 4 12.5502 4 12.0002C4 11.4502 4.45 11.0002 5 11.0002H19C19.55 11.0002 20 11.4502 20 12.0002C20 12.5502 19.55 13.0002 19 13.0002Z"
  />
</template>
